/**
 * KozéCho brand tokens — single source of truth for web theme.
 *
 * Spec ref: docs/superpowers/specs/2026-06-11-kozecho-website-design.md §3.2
 * Values reflect the validated "vibrant caribéen" identity (vert Caraïbes /
 * turquoise / orange flamme / bleu nuit).
 */

export const brandColors = {
  // Primary — vert Caraïbes (accent, boutons principaux)
  primary: '#00D1A0',
  primaryDark: '#00A580',
  primaryLight: '#1FEAB8',

  // Secondary — turquoise clair
  secondary: '#20E3D2',
  secondaryDark: '#1AC9BA',
  secondaryLight: '#4EEEE0',

  // Accent / warning — orange flamme (point focal de la marque)
  accent: '#FF7F50',
  accentDark: '#E57040',
  accentLight: '#FFAA7F',

  // Text / surfaces
  textPrimary: '#14213D', // bleu nuit
  textSecondary: '#5B6478',
  textDisabled: '#9CA3AF',
  textInverse: '#FFFFFF',

  // Backgrounds
  backgroundDefault: '#F5F7FA',
  backgroundPaper: '#FFFFFF',

  // Dark mode backgrounds (per spec §3.2)
  backgroundDefaultDark: '#0B1220',
  backgroundPaperDark: '#14213D',

  // States
  success: '#0EAA76',
  warning: '#FF7F50',
  error: '#E5484D',
  info: '#20E3D2',
} as const;

export type BrandColorKey = keyof typeof brandColors;
